export default "__VITE_ASSET__D4VUipQB__"